import { render, staticRenderFns } from "./AncientSampleDetailMobile.vue?vue&type=template&id=55b99deb&scoped=true"
import script from "./AncientSampleDetailMobile.vue?vue&type=script&lang=js"
export * from "./AncientSampleDetailMobile.vue?vue&type=script&lang=js"
import style0 from "./AncientSampleDetailMobile.vue?vue&type=style&index=0&id=55b99deb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b99deb",
  null
  
)

export default component.exports